import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { debounceTime } from 'rxjs/operators'
import { listingsFilterCallStream$ } from '@mfs/client/listings-client/helpers/filters/listingsFilterCallStream'
import { listingsFilterCall } from '@mfs/client/listings-client/actions/listings/filter/filter'

const useListingsFilterCallStream = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    const subscription = listingsFilterCallStream$
      .pipe(
        debounceTime(2000)
      )
      .subscribe((args) => {
        dispatch(listingsFilterCall(...args))
      })
    return () => subscription.unsubscribe()
  }, [dispatch])
}

export default useListingsFilterCallStream
